import { AppShell } from "./components/shell/AppShell";
import { CanvasWorkbench } from "./components/canvas/CanvasWorkbench";
import { ChatWorkbench } from "./components/chat/ChatWorkbench";
import { FilesWorkbench } from "./components/files/FilesWorkbench";
import { BrowserWorkbench } from "./components/browser/BrowserWorkbench";
import { GlobalToolsWorkbench } from "./components/tools/GlobalToolsWorkbench";
import { ProjectsWorkbench } from "./components/projects/ProjectsWorkbench";
import { ProjectToolsWorkbench } from "./components/tools/ProjectToolsWorkbench";
import { SettingsWorkbench } from "./components/settings/SettingsWorkbench";
import { TaskBoardWorkbench } from "./components/taskboard/TaskBoardWorkbench";
import { CostLedgerWorkbench } from "./components/cost/CostLedgerWorkbench";
import { MemoryWorkbench } from "./components/memory/MemoryWorkbench";
import { KnowledgeWorkbench } from "./components/knowledge/KnowledgeWorkbench";
import { QuarantineWorkbench } from "./components/quarantine/QuarantineWorkbench";
import { RecipesWorkbench } from "./components/recipes/RecipesWorkbench";
import { ArchMapWorkbench } from "./components/archmap/ArchMapWorkbench";
import { BenchmarkWorkbench } from "./components/benchmark/BenchmarkWorkbench";
import { DriftWorkbench } from "./components/drift/DriftWorkbench";
import { ProvenanceWorkbench } from "./components/provenance/ProvenanceWorkbench";
import { ReplayWorkbench } from "./components/replay/ReplayWorkbench";
import { RegistryWorkbench } from "./components/registry/RegistryWorkbench";
import { AccessControlWorkbench } from "./components/access/AccessControlWorkbench";
import { AdminConsole } from "./components/admin/AdminConsole";
import { InviteAccept } from "./components/auth/InviteAccept";
import { LoginPage } from "./components/auth/LoginPage";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { HomeSurface } from "./routes/HomeSurface";
import { ToolsSurface } from "./routes/ToolsSurface";

function AppRoutes() {
  const { user, authRequired, loading } = useAuth();

  if (loading) {
    return null;
  }

  return (
    <AppShell>
      {(route, payload) => {
        const projectName = "workspace";

        // Handle invite routes: #invite/{token}
        if (route.startsWith("invite/")) {
          const inviteToken = route.replace("invite/", "");
          return <InviteAccept inviteToken={inviteToken} />;
        }

        if (authRequired && !user) {
          return <LoginPage />;
        }

        switch (route) {
          case "chat":
            return <ChatWorkbench projectName={projectName} />;

          case "files":
            return <FilesWorkbench projectName={projectName} />;

          case "browser":
            return <BrowserWorkbench projectName={projectName} />;

          case "canvas":
            return <CanvasWorkbench payload={payload} />;

          case "projects":
            return <ProjectsWorkbench payload={payload} />;

          case "tools":
            return payload ? (
              <ProjectToolsWorkbench payload={payload} />
            ) : (
              <ToolsSurface projectName={projectName} />
            );

          case "taskboard":
            return <TaskBoardWorkbench />;

          case "cost":
            return <CostLedgerWorkbench />;

          case "memory":
            return <MemoryWorkbench />;

          case "knowledge":
            return <KnowledgeWorkbench />;

          case "quarantine":
            return <QuarantineWorkbench />;

          case "recipes":
            return <RecipesWorkbench />;

          case "archmap":
            return <ArchMapWorkbench />;

          case "benchmark":
            return <BenchmarkWorkbench />;

          case "drift":
            return <DriftWorkbench payload={payload} />;

          case "provenance":
            return <ProvenanceWorkbench payload={payload} />;

          case "replay":
            return <ReplayWorkbench />;

          case "registry":
            return <RegistryWorkbench />;

          case "access":
            return <AccessControlWorkbench />;

          case "admin":
            return <AdminConsole />;

          case "settings":
            return <SettingsWorkbench />;

          default:
            return <HomeSurface projectName={projectName} />;
        }
      }}
    </AppShell>
  );
}

export function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}
